/* PrimeChemical Corp. — entrega real del formulario de muestras.
   v1.1 · 2026-09-14
   Antes: el boton montaba un mailto y abria el cliente de correo del visitante;
   si no tenia cliente configurado, la solicitud se perdia sin aviso.
   Ahora: los campos visibles se trasladan al formulario de contacto de Shopify,
   que entrega en el correo de contacto de la tienda (licence@primechemicalcorp.com).
   Antibot: proteccion nativa de Shopify (Shopify.captcha.protect) + campo trampa
   (honeypot) + descarte de envios instantaneos. */
(function () {
  'use strict';

  var T = {
    es: {
      note: 'Tu solicitud se envia directamente a nuestro equipo tecnico. Respondemos en 48 horas laborables.',
      fill: 'Completa nombre, empresa y email de trabajo.',
      mail: 'Revisa el email: no parece una direccion valida.',
      sending: 'Enviando…',
      ok: 'Solicitud recibida. Te respondemos en 48 horas laborables.',
      err: 'No hemos podido enviar la solicitud. Escribenos a licence@primechemicalcorp.com.'
    },
    en: {
      note: 'Your request goes straight to our technical team. We answer within 48 business hours.',
      fill: 'Please fill in name, company and work email.',
      mail: 'That email address does not look valid.',
      sending: 'Sending…',
      ok: 'Request received. We will get back to you within 48 business hours.',
      err: 'We could not send your request. Please write to licence@primechemicalcorp.com.'
    },
    fr: {
      note: 'Votre demande est transmise directement a notre equipe technique. Nous repondons sous 48 heures ouvrees.',
      fill: 'Renseignez nom, societe et email professionnel.',
      mail: 'Cette adresse email ne semble pas valide.',
      sending: 'Envoi…',
      ok: 'Demande recue. Nous vous repondons sous 48 heures ouvrees.',
      err: 'Impossible d envoyer votre demande. Ecrivez-nous a licence@primechemicalcorp.com.'
    },
    it: {
      note: 'La tua richiesta arriva direttamente al nostro team tecnico. Rispondiamo entro 48 ore lavorative.',
      fill: 'Compila nome, azienda ed email di lavoro.',
      mail: 'L indirizzo email non sembra valido.',
      sending: 'Invio…',
      ok: 'Richiesta ricevuta. Ti rispondiamo entro 48 ore lavorative.',
      err: 'Non e stato possibile inviare la richiesta. Scrivici a licence@primechemicalcorp.com.'
    }
  };

  function t(k) {
    var l = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return (T[l] || T.en)[k];
  }

  function val(id) {
    var e = document.getElementById(id);
    return e ? String(e.value || '').trim() : '';
  }

  function init() {
    var real = document.getElementById('pccRealForm');
    var fake = document.getElementById('rfForm');
    var host = document.getElementById('request');
    var btn = document.getElementById('rfSend');
    if (!real || !host) { return; }

    var loadedAt = Date.now();
    var note = host.querySelector('.rf-foot small');
    var foot = host.querySelector('.rf-foot');

    function paintNote() {
      if (!note) { return; }
      note.removeAttribute('data-i18n');
      note.textContent = t('note');
    }
    paintNote();

    if (typeof window.applyLang === 'function') {
      var origApply = window.applyLang;
      window.applyLang = function () {
        var r = origApply.apply(this, arguments);
        try { paintNote(); } catch (e) {}
        return r;
      };
    }

    var status = document.createElement('p');
    status.id = 'pccStatus';
    status.setAttribute('role', 'status');
    status.style.cssText = 'margin:10px 0 0;font-size:14px;line-height:1.4;display:none';
    if (foot) { foot.parentNode.insertBefore(status, foot); }

    function say(msg, kind) {
      status.textContent = msg;
      status.style.display = 'block';
      status.style.color = kind === 'err' ? '#b3261e' : (kind === 'ok' ? '#0f7b3d' : 'inherit');
    }

    /* Resultado tras el envio (Shopify recarga la pagina) */
    if (document.getElementById('pccFormErr')) {
      say(t('err'), 'err');
      host.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (/[?&]contact_posted=true/.test(location.search)) {
      say(t('ok'), 'ok');
      if (fake) { fake.style.display = 'none'; }
      if (foot) { foot.style.display = 'none'; }
      host.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (!fake || !btn) { return; }

    /* Trasladar los campos visibles al formulario que si entrega */
    var map = {
      rfName: 'contact[name]',
      rfCompany: 'contact[Company]',
      rfEmail: 'contact[email]',
      rfCountry: 'contact[Country]',
      rfTech: 'contact[Technology]',
      rfMsg: 'contact[body]'
    };
    real.className = fake.className;
    Object.keys(map).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) { el.setAttribute('name', map[id]); real.appendChild(el); }
    });
    fake.parentNode.replaceChild(real, fake);
    var wrap = document.getElementById('pccRF');
    if (wrap && wrap.parentNode) { wrap.parentNode.removeChild(wrap); }

    var hp = document.getElementById('pccHP');
    var send = document.getElementById('pccRealSubmit');

    /* Proteccion antibot nativa de Shopify sobre el formulario ya colocado */
    var armed = false;
    (function arm(tries) {
      tries = tries || 0;
      if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
        try { window.Shopify.captcha.protect(real, function () { armed = true; }); } catch (e) {}
        armed = true;
        return;
      }
      if (tries < 40) { setTimeout(function () { arm(tries + 1); }, 250); }
    }(0));

    /* Sustituir el boton para desactivar el manejador de mailto anterior */
    var fresh = btn.cloneNode(true);
    btn.parentNode.replaceChild(fresh, btn);

    fresh.addEventListener('click', function (ev) {
      ev.preventDefault();
      var name = val('rfName'), comp = val('rfCompany'), mail = val('rfEmail');
      if (!name || !comp || !mail) { say(t('fill'), 'err'); return; }
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mail)) { say(t('mail'), 'err'); return; }
      /* Antibot: campo trampa relleno o formulario enviado en menos de 3 s */
      if ((hp && hp.value) || (Date.now() - loadedAt) < 3000) { say(t('ok'), 'ok'); return; }

      fresh.disabled = true;
      say(t('sending'), '');

      var waited = 0;
      (function go() {
        if (armed || waited >= 6000) {
          if (send) { send.click(); }
          else if (real.requestSubmit) { real.requestSubmit(); }
          else { real.submit(); }
          return;
        }
        waited += 200;
        setTimeout(go, 200);
      }());

      /* Si en 20 s no ha navegado, algo ha fallado: devolvemos el control */
      setTimeout(function () {
        if (document.getElementById('pccStatus') && status.textContent === t('sending')) {
          say(t('err'), 'err');
          fresh.disabled = false;
        }
      }, 20000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
